import { LocationModel } from "../../entities";
import { BaseODataRepository } from "../BaseODataRepository";

export class LocationODataRepo extends BaseODataRepository<LocationModel> {
  protected baseUrl = `/OData/locations`;
}

export default LocationODataRepo;
